module.exports = __webpack_public_path__ + "img/3.6bf583f2.png";